import { Component, OnInit, Injector, HostListener } from '@angular/core';
import { ShareDataService } from '../shared/service/share-data.service';
import { AppPreBootstrap } from '../../src/AppPreBootstrap';
import { StatusBar } from "@ionic-native/status-bar/ngx";
import {
  AlertController,
  NavController,
  Platform
} from "@ionic/angular";
import { Router } from '@angular/router';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Network } from '@ionic-native/network/ngx';
import { AccountService } from './_services';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Market } from "@ionic-native/market/ngx";
import { AppComponentBase } from './app-component.base';
import { MatDialog } from '@angular/material/dialog';
import { AppConsts } from '@shared/AppConsts';
import { RootedDeviceComponent } from './rooted-device/rooted-device.component';
import { StringUtils } from "../shared/utils/StringUtils";
import { environment } from '../environments/environment';

@Component({ selector: 'app-root', templateUrl: 'app.component.html' })
export class AppComponent extends AppComponentBase implements OnInit {
  constructor(
    private injector: Injector,
    private shareDataService: ShareDataService,
    private statusBar: StatusBar,
    private platform: Platform,
    private netwrok: Network,
    private router: Router,
    private accountService: AccountService,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private iab: InAppBrowser,
    private appVersion: AppVersion,
    private market: Market,
    private splashScreen: SplashScreen,
    private _dialog: MatDialog) {
      super(injector);
  }
  ionViewDidEnter() {
    setTimeout(() => {
      if (this.platform.is('cordova') || this.platform.is('android')) {
        // this.splashScreen.hide();
      }
    }, 300);
  };
  ngOnInit(): void {
    console.log("app component");
   
    // this._router.navigate(['/account/login']);
    if (this.platform.is("cordova")) {
      this.platform.resume.subscribe(() => {
      });

    }
    this.platform.ready().then(async () => {
      this.platform.pause.subscribe(() => {
      });
      console.log("platform.ready" + this.platform.is('android'));

      /**
       * here we are checking the running env of app is Prod or not
       * if prod then only we are checking if the device is rooted or not,
       */
      if (environment.production) {
        if(StringUtils.isMobilePlatform(this.platform))
        this.isDeviceRooted()
      }

      // this.statusBar.styleDefault();
      // this.statusBar.backgroundColorByHexString("#ffe49c");
      if (StringUtils.isMobilePlatform(this.platform)) {
        const androidLatestVersion = window.localStorage.getItem('currentVersionAndroid').replace(/\./g, '0');
        const iOSLatestVersion = window.localStorage.getItem('currentVersioniOS').replace(/\./g, '0');
        console.log('currentVersionAndroid local storage', androidLatestVersion);
        console.log('iOSLatestVersion local storage', iOSLatestVersion);
        this.appVersion.getVersionNumber().then(version => {
          const appVersion = version.replace(/\./g, '0');
          console.log("app Version Code app conponent " + appVersion);
          if (this.platform.is('android') && androidLatestVersion > appVersion) {
            console.log('platform android and androidLatestVersion > appVersion');
            // this.presentAlert(this.l("UserRegisterSuccessMessage"));
            this.presentAlert("Kindly update your application as the current version is no longer supported");
          } else if (this.platform.is('ios') && androidLatestVersion > appVersion) {
            console.log('platform android and iOSLatestVersion > appVersion');
            this.presentAlert("Kindly update your application as the current version is no longer supported");
          }
        });
        
      }
      
    });
   
    // if (this.netwrok.type != 'none') {
    // AppPreBootstrap.initSignalR();

    // abp.event.on('abp.notifications.received', userNotification => {
    //     // abp.notifications.showUiNotifyForUserNotification(userNotification);

    //     //Emit event
    //     this.shareDataService.newMessageReceived.emit(true);

    // });
  // }
  }

  async presentAlert(message) {
    const alert = await this.alertCtrl.create({
      // header: this.l(message),
      header: message,
      // subHeader: '10% of battery remaining',
      buttons: [
        {
          text: "Update",
          role: "OK",
          handler: () => {
            alert.dismiss();
            const appId = 'id1555638845';
            const packageName = 'com.wakandi.camsportal';
            this.platform.is('android') ? this.market.open(packageName) : this.iab.create('itms-apps://itunes.apple.com/app/id1555638845');
            // this.platform.is('android') ? this.iab.create('https://play.google.com/store/apps/details?id=com.wakandi.camsportal') : this.iab.create('itms-apps://itunes.apple.com/app/id1555638845');
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
            alert.dismiss();
          },
        },
      ],
    });
    alert.present();
  }

  /**
   * This function is used to check if the mobile device is rooted/emulator or not
   */
  isDeviceRooted() {
    if (typeof (IRoot) !== 'undefined' && IRoot) {
      IRoot.isRooted((data) => {
        if ((data && data == 1) || window['device'].isVirtual) {
          let dialog = this._dialog.open(RootedDeviceComponent, {
            id: AppConsts.dialogId.ROOTED_DEVICE_DIALOG,
            panelClass: "mini-modal",
            disableClose: true,
          });
        }
      }, (data) => {
        console.log("routed device detection failed case", data);
      });
    }
  }
  
}